import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "sticky-header-wrapper mb-14" };
const _hoisted_2 = {
    class: /*@__PURE__*/ _normalizeClass(['py-1.5 pr-0 mx-3.5'])
};
const _hoisted_3 = { class: "flex flex-col gap-0 w-full" };
const _hoisted_4 = {
    key: 0,
    class: "flex flex-col gap-2"
};
const _hoisted_5 = {
    key: 1,
    class: "w-full h-[28px] flex items-center justify-center text-sm font-semibold text-surface-400"
};
import { ref, computed, watch } from "vue";
import TreeTable from "primevue/treetable";
import Column from "primevue/column";
import TimeOffTreeTableHeader from "@/components/overview/time-off/TimeOffTreeTableHeader.vue";
import DailyCols from "@/components/overview/time-off/cols/TimeOffDailyCols.vue";
import MainParentCell from "@/components/overview/time-off/cell/TimeOffMainParentCell.vue";
import MainTimeTableCell from "@/components/overview/time-off/cell/TimeOffMainTimeTableCell.vue";
import network from "@/utils/network";
const DAILY_RANGE_LENGTH = 14;
export default /*@__PURE__*/ _defineComponent({
    __name: 'TimeOffTreeTable',
    setup(__props) {
        const filters = ref({
            query: "",
            team: [],
            onTimeOff: [true],
        });
        const headerLabels = computed(() => {
            return (timeOffItems.value[0]?.timeIntervalValues.map((interval) => interval.id) ||
                []);
        });
        const selectedDay = ref({});
        const initialSelectedDay = ref(new Date(new Date().setDate(new Date().getDate() - DAILY_RANGE_LENGTH / 2)) // 7 days ago
        );
        // Data
        const axios = network.createAxiosInstance();
        const timeOffItems = ref([]);
        const isLoadingOverview = ref(true);
        const overviewError = ref(null);
        const showOverviewSkeleton = ref(false);
        const queryParams = computed(() => {
            // @ts-ignore
            const startDate = selectedDay.value?.from;
            // @ts-ignore
            const endDate = selectedDay.value?.to;
            const params = new URLSearchParams();
            const requiredDataTypes = ["ALLOCATION", "WORK_SCHEDULE", "TIME_OFF"];
            params.set("startDate", startDate);
            params.set("endDate", endDate);
            if (filters.value.query) {
                params.set("query", filters.value.query);
            }
            if (filters.value.team?.length) {
                filters.value.team.forEach((t) => {
                    params.append("team", t);
                });
            }
            if (filters.value.onTimeOff) {
                filters.value.onTimeOff.forEach((t) => {
                    params.append("timeOff", t ? "true" : "false");
                });
            }
            requiredDataTypes.forEach((field) => {
                params.append("dataType", field);
            });
            return `?${params.toString()}`;
        });
        watch(queryParams, () => {
            fetchOverview();
        }, { immediate: false });
        const fetchOverview = async () => {
            isLoadingOverview.value = true;
            overviewError.value = null;
            timeOffItems.value = [];
            try {
                const response = await axios.get(`/v2/absence/time-off/overview${queryParams.value}`);
                timeOffItems.value = response.data || [];
            }
            catch (err) {
                console.error(err);
            }
            finally {
                isLoadingOverview.value = false;
                showOverviewSkeleton.value = false;
            }
        };
        // expandedKeys
        const expandedKeys = ref([]);
        return (_ctx, _cache) => {
            const _component_Skeleton = _resolveComponent("Skeleton");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(TimeOffTreeTableHeader, {
                    class: "border rounded-t-lg px-3.5 py-2 border-surface-100 bg-surface-0",
                    "selected-day": selectedDay.value,
                    "onUpdate:selectedDay": _cache[0] || (_cache[0] = ($event) => ((selectedDay).value = $event)),
                    "initial-selected-day": initialSelectedDay.value,
                    "day-range-length": DAILY_RANGE_LENGTH,
                    filters: filters.value,
                    "onUpdate:filters": _cache[1] || (_cache[1] = ($event) => ((filters).value = $event))
                }, null, 8, ["selected-day", "initial-selected-day", "filters"]),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_unref(TreeTable), {
                        value: timeOffItems.value,
                        scrollable: "",
                        expandedKeys: expandedKeys.value,
                        "onUpdate:expandedKeys": _cache[2] || (_cache[2] = ($event) => ((expandedKeys).value = $event))
                    }, {
                        empty: _withCtx(() => [
                            (isLoadingOverview.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(1, (i) => {
                                        return _createVNode(_component_Skeleton, {
                                            key: i,
                                            class: "w-full !h-[84px]"
                                        });
                                    }), 64)),
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (i) => {
                                        return _createVNode(_component_Skeleton, {
                                            key: i,
                                            class: "w-full !h-[56px]"
                                        });
                                    }), 64))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$tf("timeManagementOverview.noData|Nincs adat")), 1))
                        ]),
                        default: _withCtx(() => [
                            _createVNode(_unref(Column), {
                                field: "userId",
                                header: "",
                                frozen: "",
                                style: { "padding": "0 !important" },
                                class: "!border-r !border-surface-100",
                                pt: {
                                    bodycellContent: '!justify-end !h-[54px]',
                                    headercell: {
                                        style: 'background-color: var(--p-surface-0) !important;',
                                    },
                                }
                            }, {
                                body: _withCtx(({ node }) => [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createVNode(MainParentCell, { node: node }, null, 8, ["node"])
                                    ])
                                ]),
                                _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerLabels.value, (interval) => {
                                return (_openBlock(), _createBlock(_unref(Column), {
                                    key: interval,
                                    style: { "min-width": "100px", "padding": "0 !important" },
                                    pt: {
                                        bodycell: '!border-b-0',
                                    }
                                }, {
                                    header: _withCtx(() => [
                                        _createVNode(DailyCols, {
                                            "time-off-items": timeOffItems.value,
                                            interval: interval,
                                            "is-loading": isLoadingOverview.value
                                        }, null, 8, ["time-off-items", "interval", "is-loading"])
                                    ]),
                                    body: _withCtx(({ node }) => [
                                        _createElementVNode("div", _hoisted_3, [
                                            _createVNode(MainTimeTableCell, {
                                                node: node,
                                                "interval-id": interval,
                                                field: "timeOff"
                                            }, null, 8, ["node", "interval-id"])
                                        ])
                                    ]),
                                    _: 2
                                }, 1024));
                            }), 128))
                        ]),
                        _: 1
                    }, 8, ["value", "expandedKeys"])
                ])
            ]));
        };
    }
});
